import React, { useState } from "react";
import { Alert, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { setVw_Samithi_MembersList, setVw_Samithi_MembersMessage } from "redux/actions";
import { RootState } from "redux/reducers";
import { useAppDispatch } from "redux/store";
import { getVw_Samithi_Members } from "services/vw_samithi_membersService";
import Layout from "template";
import { Constant } from "template/Constant";
import { Vw_Samithi_MembersTable } from "./table";

export const Vw_Samithi_Members: React.FC = () => {
  const dispatch = useAppDispatch();
  const rData = useSelector((state: RootState) => state.vw_samithi_members);
  const [row, setRow] = useState(undefined);
  const [action, setAction] = useState('');
  const getData = (page, pageSize, searchKey) => {
    getVw_Samithi_Members(page, pageSize, searchKey).then((response) => {
      if (response && response.records) {
        dispatch(setVw_Samithi_MembersList({ pageNo: page, pageSize: pageSize, list: response.records, totalCount: response.totalCount, searchKey: searchKey }));
      } else {
		dispatch(setVw_Samithi_MembersMessage("No Record Found"));
      }
    })
  }

  const handleRowEdit = (rowData) => {
    setRow(rowData);
    dispatch(setVw_Samithi_MembersMessage(''));
    setAction('edit');
  }
  return (
    <Layout>
      <div className="container-fluid">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 className="h3 mb-0 text-gray-800">Vw_Samithi_Members</h1>
        </div>
        <div className="d-flex flex-column min-vh-100">
          {rData.message ?
            <Alert variant={Constant.defaultAlertVarient} className="alert-dismissible fade">{rData.message}
              <Button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => dispatch(setVw_Samithi_MembersMessage(''))}>
                <span aria-hidden="true">&times;</span>
              </Button>
            </Alert> : null}
         
            <Vw_Samithi_MembersTable handleRowEdit={handleRowEdit} hideShowForm={setAction} getData={getData} />
        </div>

      </div>
    </Layout >
  );
};

